import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function WarehouseIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" fill="none" viewBox="0 0 20 20" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10 6.7c4.142 0 7.5-1.12 7.5-2.5S14.142 1.7 10 1.7c-4.142 0-7.5 1.12-7.5 2.5S5.858 6.7 10 6.7Zm7.5 3.34c0 1.38-3.33 2.5-7.5 2.5s-7.5-1.12-7.5-2.5"
      />
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M2.5 4.2v11.67c0 1.38 3.33 2.5 7.5 2.5s7.5-1.12 7.5-2.5V4.2"
      />
    </Icon>
  );
}
